import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-858f40de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "breadcrumbs",
  itemscope: "",
  itemtype: "http://schema.org/BreadcrumbList"
};
const _hoisted_4 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "http://schema.org/ListItem"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  itemprop: "name"
}, "Главная", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "1"
}, null, -1));

const _hoisted_7 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "http://schema.org/ListItem"
};
const _hoisted_8 = {
  itemprop: "item"
};
const _hoisted_9 = {
  itemprop: "name"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "2"
}, null, -1));

const _hoisted_11 = {
  class: "line"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "line-right"
};
const _hoisted_14 = {
  class: "search"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "search-button"
}, null, -1));

const _hoisted_16 = {
  class: "catalog"
};
const _hoisted_17 = {
  key: 0,
  class: "pagination"
};
const _hoisted_18 = {
  class: "pagination-text"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode("Страница ");

const _hoisted_20 = {
  class: "pagination-list"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "pagination-arrows"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_WorksFilterComponent = _resolveComponent("WorksFilterComponent");

  const _component_WorkCardComponent = _resolveComponent("WorkCardComponent");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ol", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createVNode(_component_router_link, {
    itemprop: "item",
    to: {
      name: 'main'
    }
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _hoisted_6]), _createElementVNode("li", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($data.Category.name), 1)]), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("h2", _hoisted_12, _toDisplayString($data.Category.name), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("input", {
    type: "text",
    class: "search-input",
    placeholder: "Поиск",
    onChange: _cache[0] || (_cache[0] = $event => $data.search = $event.target.value)
  }, null, 32), _hoisted_15]), _createVNode(_component_WorksFilterComponent, {
    onFiltered: _cache[1] || (_cache[1] = (authorIds, years) => $options.filterWorks(authorIds, years))
  })])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_WorkCardComponent, {
    works: $data.works
  }, null, 8, ["works"])]), $data.PaginationMeta && $data.PaginationMeta.pageCount ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("b", null, _toDisplayString($data.PaginationMeta.currentPage), 1), _createTextVNode(" из " + _toDisplayString($data.PaginationMeta.pageCount), 1)]), _createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.PaginationMeta.pageCount, number => {
    return _openBlock(), _createElementBlock("li", {
      key: 'numberPage-' + number
    }, [_createElementVNode("a", {
      style: {
        "cursor": "pointer"
      },
      onClick: $event => $options.changePage(number),
      class: _normalizeClass({
        'active': number === $data.PaginationMeta.currentPage
      })
    }, _toDisplayString(number), 11, _hoisted_21)]);
  }), 128))]), _createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[2] || (_cache[2] = $event => $options.changePage($data.PaginationMeta.currentPage - 1)),
    class: "pagination-prev"
  }), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[3] || (_cache[3] = $event => $options.changePage($data.PaginationMeta.currentPage + 1)),
    class: "pagination-next"
  })])])) : _createCommentVNode("", true)])]);
}